import React from "react";
import standIcon from '../../assets/icons/stand-white.svg'
import Button from "../../components/Button/Button";
import StandTileList from "../../components/StandTileList/StandTileList";
import FeedbackPopup from "../../components/FeedbackPopup/FeedbackPopup";

const UserStands = () => {

  return (
    <div className="page-user-stands">
      <div className="row">
        <div className="col">
          <h1>Stands</h1>
        </div>
        <div className="col col-feedback">
          <FeedbackPopup
            location="/user/stands"
          />
        </div>
      </div>
      <p>Stands zijn: mobiele ondernemingen, foodtrucks, (markt) kraampje, ijs-bak-fietsen, acts, etc.</p>
      <Button
        label="Stand/Truck/Act aanmaken"
        linkState={{buttonPrev:{new:{onClick:{navigate:'/user/stands'}}}}}
        link="/wizard/stand/new"
        icon={standIcon}
      />
      <br/>
      <br/>
      <br/>
      <StandTileList/>
    </div>
  )
}

export default UserStands
